import { useMemo } from 'react';

/**
 * Hook to check if Christmas theme is enabled
 * Controlled by REACT_APP_CHRISTMAS_THEME_ENABLED environment variable
 * @returns {Object} { isChristmasMode: boolean }
 */
export const useChristmasTheme = () => {
  const isChristmasMode = useMemo(() => {
    return process.env.REACT_APP_CHRISTMAS_THEME_ENABLED === 'true';
  }, []);

  return { isChristmasMode };
};

export default useChristmasTheme;
